import { BaseModal, BaseModalProps, ModalContext } from "@pokemon/design.ui.containers.base-modal";
import React, { useContext, MouseEventHandler } from "react"
import { BasicButton } from "@pokemon/design.ui.input.basic-button";

import { ContentBox } from "@pokemon/design.ui.containers.content-box";

export interface ModalProps extends BaseModalProps {
    /**
     * what to do when someone clicks the primary modal button - defaults to closing the modal
     */
    primaryOnClick?: MouseEventHandler | undefined
    /**
     * text for the primary button, also causes the primary button to render if truthy
     */
    primaryText?: string
    /**
     * text for the secondary button that closes the modal, also causes the primary button to render if truthy
     */
    closeText?: string
    /**
     * optional title for the modal, rendered as an h2, with a matching aria-labelledby prop on the modal
     */
    title?: string
};

export const Modal = ({name, title, primaryText, closeText, children, primaryOnClick, contentBoxProps, ...otherProps} : ModalProps) => {
    const {closeModal, mobileWidth} = useContext(ModalContext)

    const closeOnClick = () => closeModal(name)

    const id = `${name}-modal-title`

    return <BaseModal
        {...otherProps}
        name={name}
        PaperComponent={(paperProps) => <ContentBox {...paperProps} customWidth={mobileWidth ? '100%' : 388} {...contentBoxProps} />}
        aria-labelledby={title && id}
        sx={{
            [` #${id}`]: {
                fontFamily: "Flexo-Bold, sans-serif",
                marginTop: '0px',
                marginBottom: '10px'
            }
        }}
    >
        {title && <h2 id={id}>{title}</h2>}
        {children}
        {
            closeText &&
                <BasicButton 
                    buttonStatus="secondary" onClick={closeOnClick}
                    text={closeText}
                />
        }
        {primaryText && 
        <BasicButton 
            onClick={primaryOnClick || closeOnClick}
            text={primaryText} 
        />}
    </BaseModal>
}

Modal.defaultProps = {
    ...BaseModal.defaultProps,
    contentBoxProps: {
        Logo: () => (<img className='logo' src={'https://static.pokemon.com/images/pokemon_logo.png'} alt={'Pokémon'} />),
        includeMeta: false,
        className: "modal-content-box"
    }
}